// extracted by mini-css-extract-plugin
export default {"link":"AnnouncementsOverviewPanel_link__uaPRW","popover":"AnnouncementsOverviewPanel_popover__+euAp","ant-popover-inner":"AnnouncementsOverviewPanel_ant-popover-inner__FlkCE"};